import { useState } from 'react';
import type { Wallet, WalletTopUp } from '@/types/portal';
import WalletDetailRow from './WalletDetailRow';
import type { WalletAction } from './WalletManageModal';

interface FundingWalletListProps {
  wallets: Wallet[];
  topUps: WalletTopUp[];
  canFund: boolean;
  onTopUp: (wallet: Wallet) => void;
  canManage: boolean;
  onManage: (wallet: Wallet, action: WalletAction) => void;
}

export default function FundingWalletList({
  wallets,
  topUps,
  canFund,
  onTopUp,
  canManage,
  onManage,
}: FundingWalletListProps) {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <header className="flex items-center justify-between gap-2 border-b border-background-200 px-5 py-4">
        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-950">Funding wallets</h3>
          <p className="mt-0.5 text-xs text-foreground-500">
            Agency float per settlement currency · open a row for its full top-up ledger
          </p>
        </div>
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-base text-accent-700">
          <i className="ri-safe-2-line" />
        </span>
      </header>

      <div className="divide-y divide-background-100">
        {wallets.map((wallet) => (
          <WalletDetailRow
            key={wallet.id}
            wallet={wallet}
            topUps={topUps.filter((entry) => entry.walletId === wallet.id)}
            expanded={expandedId === wallet.id}
            onToggle={() =>
              setExpandedId((current) => (current === wallet.id ? null : wallet.id))
            }
            canFund={canFund}
            onTopUp={() => onTopUp(wallet)}
            canManage={canManage}
            onManage={(action) => onManage(wallet, action)}
          />
        ))}
      </div>
    </section>
  );
}